
interface LocalisedText {
  [language: string]: string;
}

interface Time {
  nanos: number;
  seconds: number;
}

export enum HistoryEntryType {
  TipRating = 'tipRating',
  DialogAnswer = 'dialogAnswer',
}

export interface HistoryEntry {
  type: HistoryEntryType;
  createdAt: string;
  description: LocalisedText;
  text: LocalisedText;
  responseType: string;
  response: string;
  minLabel?: LocalisedText;
  maxLabel?: LocalisedText;
  options?: Array<Dictionary<string>>;
}
